import { config, ParallaxProvider } from '@adc/parallax-component-library';
import { QueryClientProvider } from '@tanstack/react-query';
import { useTheme as useThemeName } from 'Hooks';
import type { PropsWithChildren } from 'react';
import { queryClient } from 'Services/query';

const Providers = ({ children }: PropsWithChildren) => {
  const { theme: themeName } = useThemeName();
  const defaultTheme = themeName.endsWith('Dark') ? 'dark' : 'light';

  return (
    <QueryClientProvider client={queryClient}>
      <ParallaxProvider config={config} locale="en-US" dir="ltr" defaultTheme={defaultTheme}>
        {children}
      </ParallaxProvider>
    </QueryClientProvider>
  );
};

export { Providers };
